export default __webpack_public_path__ + "static/media/vf-closed.4312366c.svg";